// Single admin master email. Must match auth.users email used for administrative access.
// Kept in sync with the DB function public.admin_master_email().
export const ADMIN_MASTER_EMAIL = "fabiogarcia21@gmail.com";

export const isAdminMaster = (email?: string | null): boolean =>
  !!email && email.trim().toLowerCase() === ADMIN_MASTER_EMAIL.toLowerCase();
